// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1BKGa","search":"Settings_search__1c9Q9","filter":"Settings_filter__sEG1s"};